import React from 'react';
import Header from '../components/Header/Header';
import Hero from '../components/Hero/Hero';
import StatsCounter from '../components/StatsCounter/StatsCounter';
import Features from '../components/Features/Features';
import TrackAnything from '../components/TrackAnything/TrackAnything';
import UseCases from '../components/UseCases/UseCases';
import HowItWorks from '../components/HowItWorks/HowItWorks';
import Videos from '../components/Videos/Videos';
import PhoneCarousel from '../components/PhoneCarousel/PhoneCarousel';
import Comparison from '../components/Comparison/Comparison';
import Testimonials from '../components/Testimonials/Testimonials';
import TrustBanner from '../components/TrustBanner/TrustBanner';
import FAQ from '../components/FAQ/FAQ';
import Pricing from '../components/Pricing/Pricing';
import FinalCTA from '../components/FinalCTA/FinalCTA';
import Footer from '../components/Footer/Footer';
import BackgroundVideo from '../components/BackgroundVideo/BackgroundVideo';
import ChatBot from '../components/ChatBot/ChatBot';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';

const HomePage: React.FC = () => {
  const currentSection = useIntersectionObserver();

  return (
    <>
      <BackgroundVideo currentSection={currentSection} />
      <div className="App">
        <Header />
        <Hero />
        <StatsCounter />
        <Features />
        <TrackAnything />
        <UseCases />
        <HowItWorks />
        <Videos />
        <PhoneCarousel />
        <TrustBanner />
        <Comparison />
        <Testimonials />
        <FAQ />
        <Pricing />
        <FinalCTA />
        <Footer />
        <ChatBot />
      </div>
    </>
  );
};

export default HomePage;
